import React from 'react';
import { Form } from 'react-bootstrap';
import { useGetCategoriesQuery } from '../../slices/categoryApiSlice';

const CategoryFilter = ({ selectedCategory, onSelectCategory }) => {
    const { data: categories, isLoading } = useGetCategoriesQuery();

    if (isLoading) return null;

    return (
        <Form.Select
            value={selectedCategory}
            onChange={(e) => onSelectCategory(e.target.value)}
            className="form-select border-0 shadow-sm bg-light rounded-pill px-3 py-2"
            style={{ width: '100%', cursor: 'pointer', fontSize: '0.9rem' }}
            aria-label="Filtrar por categoría"
        >
            <option value="">Todas las Categorías</option>
            {categories?.map((category) => (
                <option key={category._id} value={category._id}>
                    {category.name}
                </option>
            ))}
        </Form.Select>
    );
};

export default CategoryFilter;
